// extracted by mini-css-extract-plugin
export default {"jpWrapper":"JP_Section1_jpWrapper__1nNNB"};